import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.XeroCreateContactPopup', {
    doneButtonTitle: 'Create contact',
    doneButtonText: 'Create',
    contactInformationHeader: 'Contact Information',
    billingAddressHeader: 'Billing address',
    deliveryAddressHeader: 'Delivery address',
    sameAsBillingCheckboxLabel: 'Same as Billing Address',
    salesSettingsHeader: 'Sales settings',
    purchaseSettingsHeader: 'Purchase settings',
    taxHeader: 'Tax',
    currencyHeader: 'Currency',
    batchPaymentHeader: 'Batch Payment',
    invalidContactName: 'Contact name cannot contain the following symbols: "<". ">", "&#"',
    invalidSortCode: 'Sort code should be 6 digits',
    invalidBankAccountDetails: 'Bank account number should be 8 digits',
    invalidWebsite: 'Website address is invalid',
    requiredField: 'Field "{field}" is required',
});
